<div class="tw-h-full tw-overflow-hidden ">
	<div class="tw-bg-white tw-border-b tw-border-gray-200 tw-px-4 tw-py-3 tw-font-semibold tw-text-gray-800">
		Export Notes
	</div>
	<div class="tw-p-4">
		<ul class="tree leaders tw-mb-5 tw-list-none tw-p-0">
			<ng-template #recursiveList let-list>
				<li *ngFor="let item of list" class="tw-mb-1">
					<div class="tw-flex tw-items-center tw-gap-2 tw-py-2 tw-px-2 tw-rounded-md hover:tw-bg-blue-50 tw-transition-colors">
						<div class="chapter tw-flex-1 tw-min-w-0"
							[attr.role]="item.model.typeId != 9 ? 'button' : ''"
							[class.tw-cursor-pointer]="item.model.typeId != 9"
							(click)="item.expanded = !item.expanded && item.model.typeId != 9">
							<span class="tw-inline-block tw-truncate leaders">
								<span class="tw-text-gray-600 tw-mr-2">
									<i class="fa tw-text-sm"
										[ngClass]="{
											'fa-minus-circle': item.expanded && item.model.typeId != 9,
											'fa-plus-circle': !item.expanded && item.model.typeId != 9,
											'tw-text-gray-400': item.model.typeId == 9
										}"></i>
								</span>
								<span class="tw-text-gray-800">{{ item.model.name }}</span>
							</span>
						</div>
						<div class="page tw-flex-shrink-0">
							<download-notes-button [id]="item.id"></download-notes-button>
						</div>
					</div>
					<ul *ngIf="item.children?.length > 0 && item.model.typeId != 9 && item.expanded"
						class="tw-mt-1 tw-ml-4">
						<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.children }"></ng-container>
					</ul>
				</li>
			</ng-template>
			<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: list }"></ng-container>
		</ul>
	</div>
</div>
<br>


